interface UseBreadcrumbParams {
  isFirst: boolean;
  isLast: boolean;
  isDisabledByConfig?: boolean;
}

export function useBreadcrumb({
  isFirst,
  isLast,
  isDisabledByConfig,
}: UseBreadcrumbParams) {
  return {
    isDisabled: isFirst || isLast || isDisabledByConfig,
    isActive: isLast,
  };
}
